(function () {
  const sidebar = document.getElementById('site-cart-sidebar');
  if (!sidebar) return;

  let openSheet = null;
  let activeFooterPanel = 'shipping';
  let restoreTimer;

  const shippingTrigger = () => sidebar.querySelector('[data-cart-order-slots-toggle]');
  const orderSlotsMount = () => document.getElementById('cart-order-slots-mount');

  const syncSidebarCartEmptyState = () => {
    const cartEl = document.getElementById('cart');
    if (!cartEl) return;
    sidebar.classList.toggle('cart-is-empty', cartEl.classList.contains('cart--empty'));
  };

  const relocateOrderSlotsIntoMount = () => {
    const mount = orderSlotsMount();
    const slots = document.getElementById('order-slots');
    if (!mount || !slots || mount.contains(slots)) return;
    mount.appendChild(slots);
  };

  const refreshOrderSlotsApp = () => {
    relocateOrderSlotsIntoMount();

    const cartUrl = window.KROWN?.settings?.routes?.cart_url || '/cart';

    fetch(`${cartUrl}.js`, { headers: { Accept: 'application/json' } })
      .then((response) => (response.ok ? response.json() : null))
      .then((cart) => {
        document.dispatchEvent(
          new CustomEvent('cart-updated', { bubbles: true, detail: { cart, source: 'theme-cart' } })
        );
        document.dispatchEvent(
          new CustomEvent('cart:updated', { bubbles: true, detail: { cart, source: 'theme-cart' } })
        );

        if (window.KROWN?.functions?.eventDispatcher) {
          window.KROWN.functions.eventDispatcher('krown:cart:update', { cart });
        }

        const standardCart =
          cart && window.Shopify?.StandardEvents?.CartLinesUpdateEvent?.createCartFromAjaxResponse
            ? window.Shopify.StandardEvents.CartLinesUpdateEvent.createCartFromAjaxResponse(cart)
            : null;

        const cartLinesUpdateDetail = {
          action: 'update',
          context: 'cart-drawer',
          lines:
            cart?.items?.map((item) => ({
              id: item.key ?? item.id,
              quantity: item.quantity,
            })) ?? [],
          promise: Promise.resolve({ cart: standardCart }),
        };

        if (window.KROWN?.functions?.dispatchStandardEvent) {
          window.KROWN.functions.dispatchStandardEvent('CartLinesUpdateEvent', document, cartLinesUpdateDetail);
        } else if (window.Shopify?.StandardEvents?.CartLinesUpdateEvent) {
          try {
            document.dispatchEvent(new Shopify.StandardEvents.CartLinesUpdateEvent(cartLinesUpdateDetail));
          } catch (error) {
            console.warn('order-slots: CartLinesUpdateEvent', error);
          }
        }

        ['Pickeasy', 'pickeasy', 'NeoSlotPicker'].forEach((key) => {
          const api = window[key];
          if (!api) return;
          ['refresh', 'init', 'render', 'reload'].forEach((method) => {
            if (typeof api[method] === 'function') {
              try {
                api[method](cart);
              } catch (error) {
                console.warn(`order-slots: ${key}.${method}`, error);
              }
            }
          });
        });
      })
      .catch(() => {
        document.dispatchEvent(new CustomEvent('cart-updated', { bubbles: true }));
      });
  };

  const setSheetTriggersSelected = (selectedName) => {
    sidebar.querySelectorAll('[data-cart-sheet-open]').forEach((trigger) => {
      const isSelected = selectedName && trigger.dataset.cartSheetOpen === selectedName;
      trigger.setAttribute('aria-selected', isSelected ? 'true' : 'false');
      trigger.classList.toggle('cart-sidebar-extras__trigger--active', isSelected);
    });
  };

  const showOrderSlots = ({ closeSheets = true } = {}) => {
    syncSidebarCartEmptyState();
    if (sidebar.classList.contains('cart-is-empty')) return;

    activeFooterPanel = 'shipping';

    if (closeSheets) {
      closeSheet(openSheet);
    }

    sidebar.classList.add('cart-order-slots-visible');
    const shipping = shippingTrigger();
    shipping?.setAttribute('aria-selected', 'true');
    shipping?.classList.add('cart-sidebar-extras__trigger--active');
    setSheetTriggersSelected(null);
    relocateOrderSlotsIntoMount();
  };

  const hideOrderSlots = () => {
    sidebar.classList.remove('cart-order-slots-visible');
    const shipping = shippingTrigger();
    shipping?.setAttribute('aria-selected', 'false');
    shipping?.classList.remove('cart-sidebar-extras__trigger--active');
  };

  const restoreOrderSlotsAfterCartUpdate = () => {
    clearTimeout(restoreTimer);
    restoreTimer = setTimeout(() => {
      refreshOrderSlotsApp();

      if (sidebar.classList.contains('cart-is-empty')) {
        activeFooterPanel = null;
        hideOrderSlots();
        closeSheet(openSheet);
        return;
      }

      if (activeFooterPanel === 'shipping') {
        showOrderSlots({ closeSheets: false });
      } else {
        hideOrderSlots();
      }
    }, 200);
  };

  window.KROWN = window.KROWN || { functions: {} };
  KROWN.functions = KROWN.functions || {};
  const prepareCartDrawerDefaultShipping = () => {
    activeFooterPanel = 'shipping';
    syncSidebarCartEmptyState();
  };

  KROWN.functions.showCartOrderSlots = () => showOrderSlots();
  KROWN.functions.prepareCartDrawerDefaultShipping = prepareCartDrawerDefaultShipping;
  KROWN.functions.syncSidebarCartEmptyState = syncSidebarCartEmptyState;
  KROWN.functions.hideCartOrderSlots = hideOrderSlots;
  KROWN.functions.restoreCartOrderSlotsAfterUpdate = restoreOrderSlotsAfterCartUpdate;
  KROWN.functions.relocateCartOrderSlotsIntoMount = relocateOrderSlotsIntoMount;
  KROWN.functions.refreshCartOrderSlotsApp = refreshOrderSlotsApp;

  const toggleOrderSlots = () => {
    closeSheet(openSheet);

    if (sidebar.classList.contains('cart-order-slots-visible')) {
      activeFooterPanel = null;
      hideOrderSlots();
      return;
    }

    showOrderSlots();
  };

  const closeSheet = (sheet, { restoreShipping = true } = {}) => {
    if (!sheet) return;
    sheet.classList.remove('is-open');
    sheet.setAttribute('aria-hidden', 'true');
    sheet.hidden = true;
    sidebar.classList.remove('cart-sidebar-sheet-open');
    openSheet = null;
    setSheetTriggersSelected(null);

    if (restoreShipping && !sidebar.classList.contains('cart-is-empty')) {
      showOrderSlots();
    }
  };

  const openSheetByName = (name) => {
    activeFooterPanel = name;
    hideOrderSlots();
    setSheetTriggersSelected(name);

    const sheet = sidebar.querySelector(`[data-cart-sheet="${name}"]`);
    if (!sheet) return;

    if (openSheet && openSheet !== sheet) {
      closeSheet(openSheet, { restoreShipping: false });
    }

    sheet.removeAttribute('hidden');
    requestAnimationFrame(() => {
      sheet.classList.add('is-open');
      sheet.setAttribute('aria-hidden', 'false');
      sidebar.classList.add('cart-sidebar-sheet-open');
      openSheet = sheet;
    });
  };

  sidebar.addEventListener('click', (event) => {
    if (event.target.closest('[data-cart-order-slots-toggle]')) {
      event.preventDefault();
      toggleOrderSlots();
      return;
    }

    const openBtn = event.target.closest('[data-cart-sheet-open]');
    if (openBtn) {
      event.preventDefault();
      openSheetByName(openBtn.dataset.cartSheetOpen);
      return;
    }

    if (event.target.closest('[data-cart-sheet-close]')) {
      event.preventDefault();
      closeSheet(openSheet);
      return;
    }

    const discountApply = event.target.closest('[data-cart-sheet-discount-apply]');
    if (discountApply) {
      event.preventDefault();
      const sheet = discountApply.closest('[data-cart-sheet]');
      const submit = sheet?.querySelector('[data-js-discount-submit]');
      if (submit) {
        submit.click();
      } else {
        closeSheet(openSheet);
      }
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      if (openSheet) {
        closeSheet(openSheet);
      } else if (sidebar.classList.contains('cart-order-slots-visible')) {
        activeFooterPanel = null;
        hideOrderSlots();
      }
    }
  });

  sidebar.addEventListener('sidebar:close', () => {
    closeSheet(openSheet);
    hideOrderSlots();
    activeFooterPanel = null;
  });

  if (!sidebar.classList.contains('cart-is-empty')) {
    showOrderSlots();
  }

  const footer = sidebar.querySelector('.sidebar__footer');
  if (footer) {
    new MutationObserver(() => {
      relocateOrderSlotsIntoMount();
    }).observe(footer, { childList: true, subtree: true });
  }

  const subtotal = document.getElementById('AjaxCartSubtotal');
  if (subtotal) {
    new MutationObserver(() => {
      restoreOrderSlotsAfterCartUpdate();
    }).observe(subtotal, { childList: true, subtree: true });
  }

  const cartForm = document.getElementById('AjaxCartForm');
  if (cartForm) {
    new MutationObserver(() => {
      restoreOrderSlotsAfterCartUpdate();
    }).observe(cartForm, { childList: true, subtree: true });
  }

  new MutationObserver(() => {
    if (sidebar.classList.contains('cart-is-empty')) {
      restoreOrderSlotsAfterCartUpdate();
    }
  }).observe(sidebar, { attributes: true, attributeFilter: ['class'] });
})();
